import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/ui-refactor.css";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import QrPage from "./pages/QrPage";
import StudentPage from "./pages/StudentPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import QuestionPage from "./pages/QuestionPage";
import SubmissionPage from "./pages/SubmissionPage";
import ManageStudentPage from "./pages/ManageStudentPage";
import ManageAttendance from "./pages/ManageAttendance";
import ManageQuestions from "./pages/ManageQuestions";
import AccountPage from "./pages/AccountPage";
import PasswordPage from "./pages/PasswordPage";
import PrivacyNoticePage from "./pages/PrivacyNoticePage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/HomePage",
    element: <HomePage />,
  },
  {
    path: "/QrPage",
    element: <QrPage />,
  },
  {
    path: "/StudentPage",
    element: <StudentPage />,
  },
  {
    path: "/ConfirmationPage",
    element: <ConfirmationPage />,
  },
  {
    path: "/SubmissionPage",
    element: <SubmissionPage />,
  },
  {
    path: "/QuestionPage",
    element: <QuestionPage />,
  },
  {
    path: "/ManageQuestions",
    element: <ManageQuestions />,
  },
  {
    path: "/ManageAttendance",
    element: <ManageAttendance />,
  },
  {
    path: "/ManageStudentPage",
    element: <ManageStudentPage />,
  },
  {
    path: "/AccountPage",
    element: <AccountPage />,
  },
  {
    path: "/PasswordPage",
    element: <PasswordPage />,
  },
  {
    path: "/PrivacyNotice",
    element: <PrivacyNoticePage />,
  },
  {
    path: "*",
    element: <div>404 - Page Not Found</div>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
